<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" class="text-left">
				<Color :index="index" :isQR="isQR"></Color>
			</vs-col>
			<vs-col v-if="isQR"  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" class="text-left">
				<div  class="flex justify-center items-center w-full">
					<span class="cursor-pointer" @click="popupActive = true">
						<vue-qr :text="TextQr"  :size="200" :colorDark="color"></vue-qr>
					</span>
					<vs-textarea counter="2950" class="w-full" :label="$t('MODULE.inputText')" height="140px" v-model="questionsByPage[index].content"/>
				</div>
			</vs-col>
		</vs-row>

		<vs-popup class="text-center" title="QR" :active.sync="popupActive">
	     <vue-qr :text="TextQr"  :size="560" :colorDark="color"></vue-qr>
	    </vs-popup>
	</div>

</template>
<script type="text/javascript">
	import Color from '../../componentsToQuestions/Color.vue';
	import VueQr from 'vue-qr';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Color, VueQr },
		data() {
			return {
				popupActive: false,
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Extrae el color hexadecimal de la propiedad del componente (tipo de pregunta)
             */
			color() {
				if(this.questionsByPage[this.index].properties.color === undefined ) return '#000000';
				return this.questionsByPage[this.index].properties.color;
			},
            /**
             * Extrae el contenido de la propiedad del componente (tipo de pregunta).
             */
			content() {
				if(this.questionsByPage[this.index].content !== undefined) return this.questionsByPage[this.index]['content'];
				return "";

			},
            /**
             * Captura el text ó contenido a transformar para visualizarlo en QR
             */
			TextQr: {
				get() {
					if(this.content.length === 0) return 'Lorem ipsum dolor sit amet consectetur adipisicing, elit. Ut, perspiciatis.';
					return this.content;
				},
				set(value) {
					this.questionsByPage[this.index].content = value;
				}
			},
            /**
             * verifica si el componente ó pregunta genera un QR
             */
			isQR() {
				return (this.questionsByPage[this.index].inputType === 'QRGen');
			}
		}
	}

</script>
